import React from 'react';
import PropTypes from 'prop-types';
import './Circle.scss';

export default function Circle(props) {
  const position = props.position || '';
  const size = props.size || 'medium';
  return (
    <div className={`circle d-flex align-items-center justify-content-center ${position} ${size}`}>
      <div className="inner-circle" />
    </div>
  );
}

Circle.propTypes = {
  position: PropTypes.string,
  size: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Circles/Circle.js